export default class YearsNav
{
  private readonly nav: HTMLElement;
  private readonly intersectionObserver: IntersectionObserver;
  private readonly yearSections: HTMLElement[] = [];
  private readonly handleObserverCallback: IntersectionObserverCallback;

  constructor(navWrapper: HTMLElement)
  {
    const nav = navWrapper;
    if(nav instanceof HTMLElement) {
      this.nav = nav;
    } else {
      throw new Error("years nav not found");
    }

    const sections = document.querySelectorAll('.works-masonry-year') as NodeListOf<HTMLElement>
    sections.forEach(section => this.yearSections.push(section));

    this.handleObserverCallback = this.intersectionObserverCallback.bind(this);

    this.intersectionObserver = new IntersectionObserver(this.handleObserverCallback, {
      rootMargin: '-56px 0px 0px 0px'
    });

    this.enable();
  }

  private enable(): void
  {
    this.yearSections.forEach(section => {
      this.intersectionObserver.observe(section);
    })
  }

  public destroy(): void
  {
    this.yearSections.forEach(section => {
      this.intersectionObserver.unobserve(section);
    })
  }

  private intersectionObserverCallback(entries: IntersectionObserverEntry[], observer: IntersectionObserver): void
  {
    entries.forEach(entry => {
      const anchor = this.nav.querySelector('[href="#'+entry.target.id+'"]');
      if(anchor instanceof HTMLElement) {
        const isActive = (entry.intersectionRatio > 0);
        anchor.classList.toggle('is-active', isActive);
        if(isActive && anchor.parentElement) {
          this.scrollIntoView(anchor.parentElement);
        }
      }
    })
    this.scrollAllIntoView();
  }

  private scrollAllIntoView()
  {
    let totalActiveWidth = 0;
    let firstItem: HTMLElement|null = null;

    const activeAnchors = this.nav.querySelectorAll('.is-active') as NodeListOf<HTMLAnchorElement>;
    activeAnchors.forEach(anchor => {

      const anchorParent = anchor.parentElement;
      if(anchorParent) {
        if(!firstItem) {
          firstItem = anchorParent;
        }
        totalActiveWidth += Math.ceil(anchorParent.offsetWidth);
      }
    })

    if(firstItem) {
      this.scrollIntoView(firstItem, totalActiveWidth);
    }
  }

  private scrollIntoView(anchor: HTMLElement, offsetWidth: number|null = null): void
  {
    const anchorOffsetWidth = offsetWidth ?? Math.ceil(anchor.offsetWidth);
    const anchorOffsetLeft = Math.ceil(anchor.offsetLeft);
    const scrollContainerWidth = Math.ceil(this.nav.offsetWidth);
    const scrollLeftMax = this.nav.scrollWidth - this.nav.offsetWidth;
    const scrollLeftTarget = Math.min(
      scrollLeftMax, //cap maximum scroll
      Math.max( 
        0, //cap minimum scroll
        Math.round(
          anchorOffsetLeft
          + anchorOffsetWidth / 2
          - scrollContainerWidth / 2
        )
      )
    );

    this.nav.scrollTo({
      left: scrollLeftTarget,
      behavior: 'smooth'
    })
  }
}